<template>
	<div>
		<div class="pt-8 pb-24 lg:pb-16 px-4 lg:pt-16 h-full">
			<h3 class="w-full text-center text-4xl sm:text-5xl font-semibold text-primary leading-12">
				{{ $t('installation.title1') }}
			</h3>
			<h4 class="w-full text-center text-4xl font-semibold text-default text-pretty">
				{{ $t('installation.title2') }}
			</h4>
		</div>
		<SectionContentContainer classes="-mt-16 pb-12 lg:pb-16">
			<template #items>
				<SectionInstallationContentItem
					v-for="(item, index) in $tm('installation.section-items')"
					:id="INSTALLATION_SECTION_ITEMS[index]?.id"
					:key="item"
					:copy="item"
					:viewbox="INSTALLATION_SECTION_ITEMS[index]?.viewbox"
					:image="INSTALLATION_SECTION_ITEMS[index]?.image"
					:ui="{
						container: 'lg:flex-row lg:items-center lg:grid-cols-auto lg:flex lg:py-12 mt-16 lg:mt-0'
					}"
				/>
			</template>
		</SectionContentContainer>
	</div>
</template>

<script setup lang="ts">
import { INSTALLATION_SECTION_ITEMS } from '@/constants/components/installation-sections'
</script>
